export const PERSON = {
    id: 1,
    name: `Jacob Toye`,
    phoneNumber: `021876648`,
    email: `jacob@smartrak.co.nz`,
    isDeleted: true,
    permissions: {
        canDrive: true,
        hasValidDriversLicence: true,
        canDrivePlantTypeIds: [
            1,
            11,
        ],
    },
    requirements: {
        costCentre: true,
        otherTravelReason: true,
        journeyToLocation: true,
        privateUse: true,
    },
    defaults: {
        costCentreId: 2,
    },
};



// WEBPACK FOOTER //
// ./scripts/constants/fakeData/person.js